<template>
  <div class="home">
    <img
      alt="Vue logo"
      src="../assets/logo.png"
    >
    <!-- <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <v-card
      class="mx-auto my-8"
      elevation="16"
      max-width="344"
    >
      <v-card-item>
        <v-card-title>
          Card title
        </v-card-title>

        <v-card-subtitle>
          Card subtitle secondary text
        </v-card-subtitle>
      </v-card-item>

      <v-card-text>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  }
}
</script>
